export default function PmChangeLogItem() {
  return {
    template: require('./change-log-item.html'),
    scope: {
      isDocumentScoped: '=',
      changeLogItem: '=',
      keywordFilterText: '=',
      ssTooltipAppendToSelector: '@',
    },
    transclude: {
      changeDetails: '?changeDetails',
    },
    controller: 'PmChangeLogItemController',
    controllerAs: 'pmChangeLogItemVM',
    bindToController: true,
    replace: true,
  };
}
